import { devtools } from 'config/devtools'
import { TransitionTabsCodes } from 'modules/transitionTable/interfaces/common'
import { create } from 'zustand'

import { UseCurrentTransitionTab } from './types'

export const useCurrentTransitionTab = create<UseCurrentTransitionTab>()(
  devtools(
    (set) => ({
      currentTab: TransitionTabsCodes.All,
      setCurrentTab: (currentTab) => set({ currentTab }),
      clear: () => set({ currentTab: TransitionTabsCodes.All }),
    }),
    {
      store: 'currentTransitionTab',
    },
  ),
)
